import { motion } from "framer-motion";
import { MapPin, Phone } from "lucide-react";

const venues = [
  {
    key: "bhandara",
    label: "Wedding Venue",
    title: "Bhandara, Maharashtra",
    address: "GB Club, Khat Rd, opposite Hp Petroleum, Bhandara, Khokurala, Maharashtra 441904",
    mapsUrl:
      "https://www.google.com/maps?q=GB+Club,+Khat+Rd,+opposite+Hp+Petroleum,+Bhandara,+Khokurala,+Maharashtra+441904&output=embed",
    directionsUrl:
      "https://maps.app.goo.gl/z3WaGHCBdHBhomud7",
    contact: "+91 — 7501378225",
  },
  {
    key: "hyderabad",
    label: "Reception Venue",
    title: "Hyderabad, Telangana",
    address: "Taj tristar, 1-1-40, Sarojini Devi Rd, Kalasiguda, Secunderabad, Telangana 500003",
    mapsUrl:
      "https://www.google.com/maps?q=Taj+tristar,+1-1-40,+Sarojini+Devi+Rd,+Krishna+Complex,+Kalasiguda,+Secunderabad,+Telangana+500003&output=embed",
    directionsUrl:
      "https://maps.app.goo.gl/CeVCaFpqNzSkiE9j7",
    contact: "+91 — 9848097164",
  },
];

export default function Venue() {
  return (
    <section
      id="venue"
      data-testid="venue-section"
      className="border-t border-[#EFE6D2]"
      style={{ background: "#4A1018" }}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 py-24 md:py-32 text-[#FBF5EA]">
        <p className="overline" style={{ color: "#E8902A" }}>
          <span className="divider-line mr-4" style={{ background: "#E8902A" }} />
          Travel & Directions
        </p>
        <h2 className="font-serif-wb mt-6 text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-3xl">
          Find your way <span className="italic" style={{ color: "#E8902A" }}>to us.</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-14 mt-16">
          {venues.map((v, i) => (
            <motion.div
              key={v.key}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: i * 0.12 }}
              data-testid={`venue-card-${v.key}`}
              className="flex flex-col"
            >
              <div className="aspect-[4/3] w-full border border-[#6a242f] overflow-hidden">
                <iframe
                  title={v.title}
                  src={v.mapsUrl}
                  width="100%"
                  height="100%"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  style={{ border: 0, filter: "grayscale(0.4) contrast(0.95)" }}
                />
              </div>

              <div className="mt-8">
                <p className="overline" style={{ color: "#C9A646" }}>
                  {v.label}
                </p>
                <h3 className="font-serif-wb text-3xl mt-3">{v.title}</h3>

                <div className="mt-6 space-y-3" style={{ color: "#e8d9b8" }}>
                  <div className="flex items-start gap-3">
                    <MapPin size={16} className="mt-1" style={{ color: "#E8902A" }} />
                    <p className="text-sm leading-relaxed">{v.address}</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <Phone size={16} className="mt-1" style={{ color: "#E8902A" }} />
                    <p className="text-sm leading-relaxed">{v.contact}</p>
                  </div>
                </div>

                <a
                  href={v.directionsUrl}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`venue-${v.key}-directions-button`}
                  className="mt-8 inline-flex items-center gap-2 text-[0.74rem] uppercase tracking-[0.22em] border-b border-[#E8902A] pb-1 text-[#E8902A] hover:text-white hover:border-white transition-colors"
                >
                  Open in Google Maps →
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
